import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonBold} from 'mui-tiptap';

const StyledEditorMenuButtonBold = styled(MenuButtonBold)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonBold.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonBold;
